module.exports = __webpack_public_path__ + "static/media/error.358b3e69.svg";